import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "h3 mb-3 fw-normal" }, "Create Role", -1)
const _hoisted_2 = { class: "mb-3 mt-3 row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, " Name ", -1)
const _hoisted_4 = { class: "col-sm-10" }
const _hoisted_5 = { class: "mb-3 row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "Permissions ", -1)
const _hoisted_7 = { class: "col-sm-10" }
const _hoisted_8 = ["value", "onChange"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-outline-secondary",
  type: "submit"
}, "Submit", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lable = _resolveComponent("lable")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"]))
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.formData.name) = $event)),
          class: "form-control",
          name: "name"
        }, null, 512), [
          [_vModelText, $setup.formData.name]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.permissionList, (permission) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "form-check form-check-inline col-3",
            key: permission.id
          }, [
            _createElementVNode("input", {
              type: "checkbox",
              class: "form-check-input",
              value: permission.id,
              onChange: ($event: any) => ($setup.select(permission.id,$event.target.checked))
            }, null, 40, _hoisted_8),
            _createVNode(_component_lable, { class: "form-check-label" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(permission.name), 1)
              ]),
              _: 2
            }, 1024)
          ]))
        }), 128))
      ])
    ]),
    _hoisted_9
  ], 32))
}